import { useContext, useEffect, useState } from "react";
import { getClientholdings } from "../../services/clientService";
import { thousandSeparator } from '../../util/thousandSeperator';
import { SignalRContext, SocketContext } from '../../layout/BaseLayout';
import { feedSymbol } from "../../util/feed";

const PendingTr = (props) => {


  // let socket = useContext(SocketContext);
  let signalR = useContext(SignalRContext);

  const [feedData, setfeedData] = useState({});
  const [finalPnl, setFinalPnl] = useState(0);
  const [book, setBook] = useState({
    currentPrice: 0,
    currentPriceClass: '',
    // fpnl: 0
  });
  const [pendingCheckbox, setPendingCheckbox] = useState(false);

  useEffect(() => {
    signalR.on('SendMessage', handleLiverate);
    signalR.invoke('GetLastTickBySymbol', props?.positionItem.symbolName)
    return () => {
      signalR.off("SendMessage", handleLiverate);
    }
  }, [props?.positionItem]);

  const handleLiverate = (data) => {
    if ((data.match(/\|/g) || []).length > 2) {
      data = feedSymbol(data)
      if (data.name === props?.positionItem.symbolName) {
        let cPrice = props?.positionItem.side === "BID" ? data.bid : data.ask;
        let bk = book;
        if (parseFloat(cPrice) > parseFloat(bk.currentPrice)) {
          bk.currentPriceClass = "text-blue";
        } else if (parseFloat(cPrice) < parseFloat(bk.currentPrice)) {
          bk.currentPriceClass = "text-red";
        }
        cPrice = parseFloat(cPrice).toFixed(props?.positionItem.symbolDigit);
        bk.currentPrice = cPrice;
        setBook({ ...bk });

      }
    }
  };


  const positionClick = () => {
    let ppitm = props.positionItem;
    ppitm['fpnl'] = book.fpnl;
    ppitm['currentPrice'] = book.currentPrice;
    ppitm['currentPriceClass'] = book.currentPriceClass;
    ppitm['type'] = 'pending';
    props.selectSymbole(ppitm);
  }

  return (
    <>
      <tr onClick={() => { positionClick() }}>
        <td className="w-75 font-12 font-bold">
          <div className="">
            <span className="font-12 font-bold mr-2">{props.positionItem.symbolName}</span>
            <span className={`font-12 font-bold ${props?.positionItem.side === 'ASK' ? 'text-blue' : 'text-red'}`}>{props?.positionItem.side === 'ASK' ? 'buy limit ' : 'sell limit '} 
              {/* {!!props?.positionItem.volume ? (props?.positionItem.volume.toString().includes('.') ? props?.positionItem.volume.toFixed(2) : props?.positionItem.volume) : 0} */}
              {!!props?.positionItem.volume ? props?.positionItem.volume : 0}
              </span>
          </div>
          <div>
            <span className="font-12 mr-2">{!!props?.positionItem.price ? props?.positionItem.price.toFixed(props?.positionItem.symbolDigit) : 0}</span>
            <span className="himg-trade mr-2"><img src={"/images/arrow-right.svg"} alt="" /></span>
            <span className={`font-12`}>{!!book.currentPrice ? parseFloat(book.currentPrice).toFixed(props.positionItem.symbolDigit) : (!!props.positionItem.currentPrice ? parseFloat(props.positionItem.currentPrice).toFixed(props.positionItem.symbolDigit) : 0)}</span>
          </div>
        </td>
        <td className={`w-25 font-12 font-bold text-right `}>placed</td>

      </tr>
    </>
  )
}

export default PendingTr;